import React from "react";
import "./Svg.scss";

export const SvgWave = () => {
  return (
    <div className="wave">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="svg-wave"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="0"
        height="0"
        preserveAspectRatio="none"
        viewBox="0 0 1440 560"
      >
        <g className="svg-paths">
          <rect width="1440" height="560" x="0" y="0" fill="#1A1414"></rect>
          <path
            className="path1"
            d="M0,612.995C113.318,596.523,161.466,460.5,247.062,384.437C316.528,322.708,411.825,290.035,455.65,208.088C500.694,123.86,496.541,24.813,490.36,-70.503C483.735,-172.667,483.13,-283.239,418.631,-362.746C353.535,-442.99,245.493,-469.48,145.518,-495.589C48.06,-521.041,-51.174,-530.111,-150.125,-511.28C-256.824,-490.974,-372.481,-466.465,-442.741,-383.637C-512.821,-301.021,-508.358,-182.486,-520.362,-74.817C-531.994,29.518,-551.632,136.589,-511.56,233.621C-470.794,332.333,-383.764,400.05,-297.981,463.667C-206.897,531.215,-112.219,629.308,0,612.995"
            fill="#1c1616"
          ></path>
          <path
            className="path2"
            d="M1440 1192.8600000000001C1556.502 1182.161 1656.1779999999999 1111.2440000000001 1746.394 1036.758 1828.6109999999999 968.876 1880.455 877.858 1933.525 785.386 1992.0059999999999 683.485 2096.482 584.055 2072.17 469.108 2047.708 353.45500000000004 1897.841 319.56100000000004 1816.798 233.503 1740.394 152.37099999999998 1715.086 17.751999999999953 1610.603-21.020999999999958 1505.547-60.00599999999997 1395.3220000000001 10.623000000000047 1286.331 36.652000000000044 1170.618 64.28699999999998 1035.358 52.36500000000001 951.2049999999999 136.457 866.049 221.55200000000002 871.818 356.88800000000003 847.813 474.856 822.241 600.526 758.703 730.327 806.113 849.4870000000001 853.941 969.698 981.412 1034.944 1095.17 1096.566 1202.274 1154.583 1318.702 1204 1440 1192.8600000000001"
            fill="#1c1616"
          ></path>
        </g>
        <defs>
          <mask id="SvgjsMask1002">
            <rect width="1440" height="560" fill="#ffffff"></rect>
          </mask>
        </defs>
      </svg>
    </div>
  );
};
